import type { JSX } from "react";

import { Badge, Flex, Text } from "@mantine/core";

import type { ChallengeCondition } from "@/sales-tools/challenges/api/getChallengesForEmployee";

import { DownTriangle } from "@/sales-tools/widgets/icons/DownTriangle";

import classes from "./ChallengeLimit.module.css";

export function ChallengeLimit({ limit }: { limit: ChallengeCondition }): JSX.Element {
    const { goalType, currentValue, targetValue, threshold } = limit;
    return (
        <>
            <Flex align="center">
                <DownTriangle />
                <Text ml="3xs" data-testid="challenge-limit-current-value" fw={700} c="dark.0" size="xs">
                    {currentValue}
                </Text>
                <Text data-testid="challenge-limit-goal-type" ml="3xs" mr="4xs" c="dark.2" size="xs">
                    {goalType}
                </Text>
                <Badge color="dark.4" mx={3} h={3} w={3} circle className={classes.badge} />
                <Text data-testid="challenge-limit-explanation" ml="3xs" c="dark.2" size="xs">
                    {threshold === "UPPER_LIMIT" ? "Max" : "Minimum"} {targetValue}
                </Text>
            </Flex>
        </>
    );
}
